import { Typography } from "@hellocarbo/lasagne";
import { Widget } from "@typeform/embed-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { NavigationMenuLinks } from "@/components/NavigationMenu";
import { UserContext } from "@/contexts";
import { CustomUIMatch } from "@/hooks/useBreadcrumbs";

export const handle = {
  activeMenuLink: () => NavigationMenuLinks.restitution,
  breadcrumb: ({ reviewId }) => {
    return [
      {
        href: `/reviews/${reviewId}/feedback`,
        label: "review:feedback.breadcrumbLabel",
      },
    ];
  },
} as CustomUIMatch["handle"];

function Feedback() {
  const { t, i18n } = useTranslation(["review"]);
  const { user } = useContext(UserContext);

  const email = user?.email || "";
  const company = user?.company?.name || "";

  const typeformId = i18n.language.startsWith("fr") ? "jd6lsJrs" : "oZ807X7P";

  return (
    <div className="my-lg min-h-screen">
      <Typography step="3" as="h1" weight="bold" className="mb-sm">
        {t("review:feedback.title")}
      </Typography>

      <div className="mt-md">
        <Widget
          id={typeformId}
          hidden={{ email, company }}
          style={{ width: "95%", height: "600px" }}
        />
      </div>
    </div>
  );
}

export default Feedback;
